<template>
  <div id="block-level">
    <NewsRoom>
      <div class="col-span-1 px-[1.4286rem] md:px-0 lg:col-span-3">
        <div class="pb-[4rem]">
          <SearchNav :fallbackUrl="URL_CONFIG.NEWS_ROOM" :searchBar="false" />
          <PressReleasesContent v-if="!error && !pending && newsRoomDetailData" 
            :title="newsRoomDetailData.title"
            :image="newsRoomDetailData.image" 
            :imageAlt="newsRoomDetailData.altImage"
            :content="newsRoomDetailData.content" />
          <div v-else-if="error" class="text-red-500">
            {{ error.message }}
          </div>
          <div v-else-if="pending" class="text-gray-500">
            Loading...
          </div>
        </div>
      </div>
    </NewsRoom>
  </div>
</template>

<script setup lang="ts">
import {computed , watchEffect } from "vue"
import NewsRoom from "~/layouts/newsRoom.vue";
import { CONTENT_TYPES } from '~~/shared/utils/contentTypes';
import { PAGE_META } from "~~/shared/utils/pageMeta";
import { URL_CONFIG } from "~~/shared/utils/url.const";
import { useNewsRoomDetail } from '~/composables/useNewsRoomDetail';
import SearchNav from "~/components/ui/organism/take-five-daily/searchNav.vue";
import PressReleasesContent from "~/components/ui/organism/press-releases/pressReleasesContent.vue";

definePageMeta({
  layout: CONTENT_TYPES.NEWSROOM as any
});

const { data: newsRoomDetailData, error, pending } = useNewsRoomDetail();

useSeoMeta({
    title: computed(() => {
        if (newsRoomDetailData.value?.metaTitle) {
            return `${newsRoomDetailData.value.metaTitle} | Thorne`;
        }
        if (newsRoomDetailData.value?.title) {
            return `${newsRoomDetailData.value.title} | Thorne`;
        }
        return PAGE_META.NEWSROOM.title;
    }),
    description: computed(() => {
        return newsRoomDetailData.value?.metaDescription || 
               newsRoomDetailData.value?.title || 
               'Read the latest press releases and news from Thorne HealthTech.';
    })
});

watchEffect(() => {
  if (!pending.value && !newsRoomDetailData.value) {
    showError({
      statusCode: 404,
      statusMessage: "Page Not Found",
    });
  }
});

</script>
